import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            精彩推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选的优质漫画作品，每一部都值得你下拉滚动沉浸畅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 汗汗漫画推荐`}
                  className="w-full aspect-[4/3] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-[11px] font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="flex items-center gap-1 px-2 py-1 rounded-full bg-black/50 text-white text-[11px]">
                    <i className="ri-eye-line" />
                    {item.reads}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-semibold text-sm md:text-base text-foreground-950 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}